import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class CostIndex extends Form {

    constructor(data = {}) {
        super(data);

        this.cost_indexes = false;
    }

    index(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/cost-index?page=' + self.page;

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    all() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/cost-index/all', self.data)
                .then(response => {

                    self.cost_indexes = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    createCostIndex() {
        let self = this;
        let data = this.sanitizeData(['discount_adjustment', 'transaction_fee']);

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/cost-index', data)
                .then(response => {

                    self.data = response.data.data;

                    self.setSuccessMessage('Cost Index created.')
                    self.setFormUpdateComplete();

                    this.data = {};

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

}
